import { FGTextAreaInput } from "nsitools-react";
import React from "react";
import { useHistory } from "react-router";
import * as Yup from "yup";

import {
  ClubRoleApi,
  ClubRoleDto,
  ClubRoleTranslationDto,
} from "../../../../api";
import { FGMultiTranslate, SmallFormGenerator } from "../../../../components";
import { useGlobalData } from "../../../../contexts";
import { ERoutes } from "../../../../ERoutes";
import { useApiService, useCrudApi, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";

export interface IClubRoleDetailPageProps {
  editMode: boolean;
  idClubRole: number;
}

export const ClubRoleDetailPage: React.FunctionComponent<IClubRoleDetailPageProps> = ({
  editMode,
  idClubRole,
}) => {
  const { t } = useTl();
  const api = useApiService(ClubRoleApi);
  const history = useHistory();
  const { languages } = useGlobalData();

  const FormSchema = React.useMemo(() => {
    return Yup.object().shape({
      clubRoleTranslations: Yup.array().of(
        Yup.object().shape({
          text: Yup.string().nullable().required(t(ETLCodes.Required)),
        })
      ),
    });
  }, [t]);

  const { data, loading, deleteItem, deleting, saveItem, saving } = useCrudApi(
    {
      getApiFn: (id = idClubRole) =>
        id > 0
          ? api.getClubRole(id)
          : new ClubRoleDto({
              clubRoleTranslations: [
                ...languages.map(
                  (l) =>
                    new ClubRoleTranslationDto({
                      languageId: l.languageId,
                    })
                ),
              ],
            }).toJSON(),
      saveApiFn: (d: ClubRoleDto) => api.saveClubRole(d),
      onSavedRoute: (d) => `${ERoutes.clubRoles}/${d.clubRoleId}/detail/edit`,
      deleteApiFn: (d) => api.deleteClubRole(d.clubRoleId),
      onDeletedRoute: () => ERoutes.clubRoles,
    },
    [idClubRole]
  );

  return (
    <SmallFormGenerator
      initialValues={data}
      onSubmit={saveItem}
      editMode={editMode}
      validationSchema={FormSchema}
      loading={loading}
      onCancel={() => history.push(ERoutes.clubRoles)}
      onDelete={deleteItem}
      showDeleteButton={idClubRole > 0}
      saving={saving}
      deleting={deleting}
    >
      <FGMultiTranslate
        label={ETLCodes.Name}
        translationsArrayField="clubRoleTranslations"
        translationField="text"
        translationDto={ClubRoleTranslationDto}
      />
      <FGTextAreaInput label={t(ETLCodes.Remark)} name="remark" />
    </SmallFormGenerator>
  );
};
